import React, { useState, useMemo } from 'react';
import Sidebar from '../../components/Sidebar';
import Header from './Header';
import UnifiedSearchFilterBar from '../../components/UnifiedSearchFilterBar';
import StudentResults from './StudentResults';
import StudentChangeForm from './StudentChangeForm';
import ConfirmationModal from './ConfirmationModal';
import styles from '../../styles/CambioGrupoStyles/CambioGrupo.module.css';
import { getCampus } from '../../api/campus';
import { getSecciones } from '../../api/secciones_academicas';

function CambioGrupoScreen() {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [changeData, setChangeData] = useState(null);
  const [filters, setFilters] = useState({
    campus: '',
    seccion: ''
  });

  // Configuración de filtros para UnifiedSearchFilterBar
  const filterConfig = useMemo(() => [
    {
      key: 'campus',
      label: 'Campus',
      apiService: getCampus,
      idField: 'id_campus',
      labelField: 'nombre_campus',
      setDefault: true,
      defaultOption: 'Todos los campus'
    },
    {
      key: 'seccion',
      label: 'Sección',
      apiService: getSecciones,
      idField: 'id_seccion',
      labelField: 'nombre_seccion',
      setDefault: true,
      defaultOption: 'Todas las secciones'
    }
  ], []);

  // Mock data para estudiantes
  const students = [
    {
      id: 1,
      nombre: 'Daniel Alejandro Martínez Rivas',
      matricula: '01-000123',
      campus: 'Venustiano',
      seccion: 'Licenciatura',
      programa: 'Ingeniería en Sistemas',
      cicloEscolar: '2025-T3',
      periodoActual: '2025 (Tetramestre 3)',
      institucion: 'Universidad Lux',
      grupoActual: 'G-035',
      materiaActual: 'Cálculo'
    },
    {
      id: 2,
      nombre: 'Diego Andrés Aranda Lozano',
      matricula: '01-000156',
      campus: 'Venustiano',
      seccion: 'Licenciatura',
      programa: 'Licenciatura en Administración',
      cicloEscolar: '2025-T3',
      periodoActual: '2025 (Tetramestre 3)',
      institucion: 'Universidad Lux',
      grupoActual: 'G-042',
      materiaActual: 'Administración'
    }
  ];

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const handleStudentSelect = (student) => {
    setSelectedStudent(student);
  };

  const handleBackToSearch = () => {
    setSelectedStudent(null);
  };

  const handleChangeSubmit = (data) => {
    setChangeData(data);
    setShowConfirmation(true);
  };

  const handleConfirmChange = () => {
    // Aquí iría la lógica para procesar el cambio
    console.log('Cambio confirmado:', changeData);
    setShowConfirmation(false);
    setSelectedStudent(null);
    setChangeData(null);
  };

  const handleCancelChange = () => {
    setShowConfirmation(false);
    setChangeData(null);
  };

  // Filtrar estudiantes
  const filteredStudents = students.filter(student => {
    const matchesSearch = searchTerm === '' || 
                         student.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         student.matricula.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCampus = filters.campus === 'Todos' || student.campus.includes(filters.campus.split(' ')[0]);
    const matchesSeccion = filters.seccion === 'Todos' || student.seccion === filters.seccion;
    
    return matchesSearch && matchesCampus && matchesSeccion;
  });

  return (
    <div className={styles.layout}>
      <div className={styles.sidebarColumn}>
        <Sidebar />
      </div>
      
      <div className={styles.contentColumn}>
        <div className={styles.contentArea}>
          <div className={styles.contentWrapper}>
            {!selectedStudent ? (
              <>
                <Header />
                <UnifiedSearchFilterBar
                  filterConfig={filterConfig}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  searchTerm={searchTerm}
                  onSearch={handleSearch}
                  searchPlaceholder="Buscar Estudiante por Matrícula o Nombre"
                  searchButtonText="Buscar"
                />
                <StudentResults 
                  students={filteredStudents}
                  onStudentSelect={handleStudentSelect}
                />
              </>
            ) : (
              <StudentChangeForm 
                student={selectedStudent}
                onBack={handleBackToSearch}
                onSubmit={handleChangeSubmit}
              />
            )}
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && changeData && (
        <ConfirmationModal 
          student={selectedStudent}
          changeData={changeData}
          onConfirm={handleConfirmChange}
          onCancel={handleCancelChange}
        />
      )}
    </div>
  );
}

export default CambioGrupoScreen;
